import useJumboAuth from "@jumbo/hooks/useJumboAuth";
import Div from "@jumbo/shared/Div";
import useSwalWrapper from "@jumbo/vendors/sweetalert2/hooks";
import { LoadingButton } from "@mui/lab";
import {
  Button,
  Checkbox,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  FormControlLabel,
  Grid,
  InputAdornment,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  TextareaAutosize,
} from "@mui/material";
import jwtAuthAxios from "app/services/auth/jwtAuth";
import TableSkeleton from "app/shared/widgets/TableSkeleton";
import { BACKEND_APP_URL } from "app/utils/constants/paths";
import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import CheckBoxOutlinedIcon from "@mui/icons-material/CheckBoxOutlined";
import NoDataPlaceholder from "app/shared/NoDataPlaceholder";
import styled from "@emotion/styled";
import { Field, Formik } from "formik";
import { DataGrid } from "@mui/x-data-grid";
import * as Yup from "yup";
import csvToJson from "app/shared/csvToJson";
const validationSchema = Yup.object().shape({
  FL_BANK_CODE: Yup.string().required("Bank is required"),
  // narration: Yup.string().required('Narration is required'),
});
// export default function PartyTransactionDetailMain() {
// return 1
// }
export default function PartyTransactionDetail() {
  const { type, prid, trid } = useParams();

  const [MData, setMData] = useState(null);
  const [CurrData, setCurrData] = useState({});

  const [SelectedStone, setSelectedStone] = useState([]);

  const [SelectedStoneDetail, setSelectedStoneDetail] = useState([]);
  const [open, setOpen] = useState(false);
  const handleClose = () => setOpen(!open);
  const swal = useSwalWrapper();
  const jumboco = useJumboAuth();
  const fetchtrdata = () => {
    setMData(null);
    setSelectedStone([]);
    jwtAuthAxios
      .get(
        "transation/stoneByParty?partyId=" +
          prid +
          "&trtype=" +
          type +
          "&MemoNO=" +
          trid
      )
      .then((res) => {
        let sData = res.data?.data?.sort((a, b) =>
          a.FL_STONE_ID > b.FL_STONE_ID ? 1 : -1
        );

        setMData(sData);
        setCurrData(res.data?.CUR);
      })
      .catch(() => {
        setMData([]);
        setSelectedStone([]);
        swal.fire({
          icon: "error",
          text: "something Went Wrong",
        });
      });
  };
  useEffect(() => {
    fetchtrdata();
  }, []);
  const setdelctendStoneDetail = () => {
    let seData = MData?.filter((st) => SelectedStone?.includes(st.FL_STONE_ID));
    setSelectedStoneDetail(seData);
    return true;
  };

  const memoReturnHandler = async () => {
    // let StoneData = MData?.filter((d) => SelectedStone.includes(d.FL_STONE_ID));
    let StoneDetaildata = MData?.filter(d => SelectedStone.includes(d.FL_STONE_ID))
    console.log(StoneDetaildata);
    let StoneData =StoneDetaildata.map(({FL_SRNO,CARATS,FL_STONE_ID})=>({FL_SRNO,CARATS,FL_STONE_ID}))
    await jwtAuthAxios
      .post(
        `${
          CurrData?.FL_DIAMOND_TYPE == "JEWELRY"
            ? "transation/jewelMemoreturn"
            : "transation/polishMemoreturn"
        }`,
        {
          StoneData: StoneData,
          Party: prid,
          trno: trid,
        }
      )
      .then((res) => {
        swal.fire({
          icon: "success",
          text: res.data.message,
        });
        fetchtrdata();
      })
      .catch((e) => {
        swal.fire({
          icon: "error",
          text: "Internal server Error",
        });
      });
  };
  const handleStoneSelect = (stone) => {
    if (SelectedStone.indexOf(stone) === -1) {
      // If the stone is not in SelectedStone, add it
      setSelectedStone([...SelectedStone, stone]);
    } else {
      // If the stone exists in SelectedStone, remove it
      const updatedStones = SelectedStone?.filter((s) => s !== stone);
      setSelectedStone(updatedStones);
    }
  };
  const handlediscChang = async (e, stone, type) => {
    let tmpStoneData = stone;
    let targetData = e.target?.id.split("-");

    if (type == 0) {
      let disc = e.target.value;
      tmpStoneData = { ...tmpStoneData, MDISC: disc };
    } else if (type == 1) {
      tmpStoneData = {
        ...tmpStoneData,
        MDISC: 100 - (e.target.value * 100) / stone.FL_RAP_PRICE_US,
      };
    } else if (type == 2) {
      let tmpAMT = e.target.value / stone.CARATS;
      tmpStoneData = {
        ...tmpStoneData,
        MDISC: 100 - (tmpAMT * 100) / stone.FL_RAP_PRICE_US,
      };
    } else if (type == 3) {
      let tmpAMT = e.target.value;
      tmpStoneData = {
        ...tmpStoneData,
        FL_AMT2: Number(tmpAMT),
      };
    }
    let ManageStoneDisc = MData?.filter(
      (sd) => sd.FL_STONE_ID !== stone.FL_STONE_ID
    );
    let tmpprice =
      stone.FL_RAP_PRICE_US -
      (stone.FL_RAP_PRICE_US * tmpStoneData.MDISC) / 100;
    let FinalObj = {
      ...tmpStoneData,
      mPrice: tmpprice,
      mamt: tmpprice * stone.CARATS,
    };
    ManageStoneDisc.push(FinalObj);

    // Sort the array by the FL_STONE_ID property in ascending order
    ManageStoneDisc.sort((a, b) => (a.FL_STONE_ID > b.FL_STONE_ID ? 1 : -1));

    const element0 = document.getElementById(
      `${targetData[0]}-0-${targetData[2]}`
    );
    const element1 = document.getElementById(
      `${targetData[0]}-1-${targetData[2]}`
    );
    const element2 = document.getElementById(
      `${targetData[0]}-2-${targetData[2]}`
    );

    if (type !== 0 && element0) {
      element0.value = FinalObj?.MDISC?.toFixed(2);
    }

    if (type !== 1 && element1) {
      element1.value = FinalObj.mPrice?.toFixed(2);
    }

    if (type !== 2 && element2) {
      element2.value = FinalObj.mamt?.toFixed(2);
    }

    // if (type !== 0) {
    //   document.getElementById(`${targetData[0]}-0-${targetData[2]}`).value =
    //     FinalObj?.MDISC?.toFixed(2);
    // }
    // if (type !== 1) {
    //   document.getElementById(`${targetData[0]}-1-${targetData[2]}`).value =
    //     FinalObj.mPrice?.toFixed(2);
    // }
    // if (type !== 2) {
    //   document.getElementById(`${targetData[0]}-2-${targetData[2]}`).value =
    //     FinalObj.mamt?.toFixed(2);
    // }
    // Set the sorted array to the state (assuming you're using React useState)

    setMData(ManageStoneDisc);
  };
  const SavememoHandler = async () => {
    await jwtAuthAxios
      .post("transation/saveMemo", {
        data: MData.map((s) => ({
          STONE: s.FL_STONE_ID,
          MDISC: Number(s.MDISC),
          RAP: s.RAP_PRICE,
          CARATS: s.CARATS,
        })),
        MemoNo: trid,
        party: prid,
        type: type,
        convRate: Number(CurrData?.FL_CONV_RATE),
      })
      .then((res) =>
        swal.fire({
          icon: "success",
          text: res.data.message,
        })
      )
      .catch((e) =>
        swal.fire({
          icon: "error",
          text: "Internal server Error",
        })
      );
  };
  const PolishParcelTransactionS = () => {
    const [bulkmemoDialoge, setBulkmemoDialoge] = useState(null);
    const [processType, setProcessType] = useState(null);

    const [bulkSelectrdlot, setBulkSelectrdlot] = useState([]);
    const [bulkSelectrdstoneDataVal, setBulkSelectrdstoneDataVal] = useState(
      []
    );
    const [bulkSelectrdMemoRetrDat, setBulkSelectrdMemoRetrDat] = useState([]);
    const [disabledButton, setdisabledButton] = useState({});

    const [rows, setrows] = useState({});
    const apirefdatagrid = useRef(null);
    const apirefdatagridmts = useRef(null);
    const apirefdatagridMain = useRef(null);
    const column = [
      { field: "FL_STONE_ID", headerName: "Lot ID", flex: 1 },
      { field: "SHAPE", headerName: "Shape", flex: 1 },
      { field: "CARATS", headerName: "CARATS", flex: 1 },
      { field: "COLOR", headerName: "Color", flex: 1 },
      { field: "FL_CLARITY", headerName: "Clarity", flex: 1 },
      {
        field: "FL_SALERATE",
        headerName: "Amt/cts",
        cellClassName: "editable-cell",
        flex: 1,
        editable: true,
        type: "number",
        valueFormatter: (params) => {
          // Use the valueFormatter function to format the value without commas
          return params.value ? params.value?.toFixed(2).toString() : "";
        },
      },
      {
        field: "FL_SALE_AMT",
        headerName: "Sale Amt($)",
        flex: 1,
        type: "number",
        valueGetter: (p) => p.row.FL_SALERATE * p.row.CARATS,
      },
      {
        field: "FL_SALE_AMT_r",
        headerName: `Sale Amt(${jumboco?.curr?.cd})`,
        type: "number",
        flex: 1,
        valueGetter: (p) =>
          (p.row.FL_SALERATE * p.row.CARATS * CurrData.FL_CONV_RATE).toFixed(2),
      },
      { field: "FL_RET_CTS_P", headerName: "ret/cts", flex: 1 },
      { field: "FL_KEPT_CTS_P", headerName: "kept/cts", flex: 1 },
    ];
    const memoReturnColumn = [
      { field: "FL_STONE_ID", headerName: "Lot ID", flex: 1 },
      { field: "FL_SALERATE", headerName: "Amt/cts", flex: 1 },
      { field: "CARATS", headerName: "Awailable CARATS", flex: 1 },
      {
        field: "FL_RET_CTS",
        headerName: "Ret/cts",
        flex: 1,
        type: "number",
        editable: true,
        cellClassName: "editable-cell",
      },
      // { field: 'FL_WGT_LOSS', headerName: 'Wgt Loss', flex: 1, type: 'number', editable: true, cellClassName: 'editable-cell' },
    ];
    const memoToSoldColumn = [
      { field: "FL_STONE_ID", headerName: "Lot ID", flex: 1 },
      { field: "FL_SALERATE", headerName: "Amt/cts", flex: 1 },
      { field: "CARATS", headerName: "Awailable CARATS", flex: 1 },
      {
        field: "FL_KEPT_CTS",
        headerName: "Kept/cts",
        flex: 1,
        type: "number",
        editable: true,
        cellClassName: "editable-cell",
      },
    ];
    const handleMemoReturn = () => {
      setBulkSelectrdstoneDataVal(
        MData.filter((s) => bulkSelectrdlot.includes(s.FL_STONE_ID))
      );
      setProcessType("mr");
    };
    const handleMemoToSale = () => {
      setBulkSelectrdstoneDataVal(
        MData.filter((s) => bulkSelectrdlot.includes(s.FL_STONE_ID))
      );
      setProcessType("mts");
    };
    const handleCellEditMain = async (params) => {
      setTimeout(async () => {
        let cellval = await apirefdatagrid.current.getCellValue(
          params.id,
          params.field
        );
        // console.log(cellval);
        // Update the data source with the new value
        // alert('commit')
        const updatedRows = MData.map((row) => {
          if (row.FL_STONE_ID === params.id) {
            return { ...row, [params.field]: cellval };
          }
          return row;
        });
        setMData(updatedRows);
      }, 100);
    };
    const handleCellEditMTS = async (params) => {
      setTimeout(async () => {
        let cellval = await apirefdatagridmts.current.getCellValue(
          params.id,
          params.field
        );
        // console.log(cellval);
        // Update the data source with the new value
        // alert('commit')
        const updatedRows = bulkSelectrdstoneDataVal.map((row) => {
          if (row.FL_STONE_ID === params.id) {
            if (params.field === "FL_RET_CTS") {
              return {
                ...row,
                [params.field]: cellval <= row.CARATS ? cellval : row.CARATS,
              };
            } // else if(params.field ===  'FL_WGT_LOSS') {
            //   return { ...row, [params.field]: cellval <= row.CARATS ? cellval : 0  };
            // }
            else {
              return { ...row, [params.field]: cellval };
            }
          }
          return row;
        });
        setBulkSelectrdstoneDataVal(updatedRows);
      }, 100);
    };
    const handleCellEdit = async (params) => {
      setTimeout(async () => {
        let cellval = await apirefdatagrid.current.getCellValue(
          params.id,
          params.field
        );
        // console.log(cellval);
        // Update the data source with the new value
        // alert('commit')
        const updatedRows = bulkSelectrdstoneDataVal.map((row) => {
          if (row.FL_STONE_ID === params.id) {
            if (params.field === "FL_RET_CTS") {
              return {
                ...row,
                [params.field]: cellval <= row.CARATS ? cellval : row.CARATS,
              };
            } // else if(params.field ===  'FL_WGT_LOSS') {
            //   return { ...row, [params.field]: cellval <= row.CARATS ? cellval : 0  };
            // }
            else {
              return { ...row, [params.field]: cellval };
            }
          }
          return row;
        });
        setBulkSelectrdstoneDataVal(updatedRows);
      }, 100);
    };
    const returnMemoBulkHandler = async () => {
      await jwtAuthAxios
        .post("transation/bulk/polishMemoreturn", {
          type,
          prid,
          trid,
          StoneData: bulkSelectrdstoneDataVal,
        })
        .then((res) => {
          swal.fire({
            icon: "success",
            text: res.data.message,
          });
          fetchtrdata();
        })
        .catch((e) => {
          swal.fire({
            icon: "error",
            text: "Internal server Error",
          });
        });
    };
    const getSelectedCellValues = async () => {
      let stonData = csvToJson(apirefdatagridMain.current.getDataAsCsv());
      await jwtAuthAxios
        .post("transation/bulk/saveMemo", {
          data: stonData,
          MemoNo: trid,
          party: prid,
          type: type,
          convRate: Number(CurrData?.FL_CONV_RATE),
        })
        .then((res) =>
          swal.fire({
            icon: "success",
            text: res.data.message,
          })
        )
        .catch((e) =>
          swal.fire({
            icon: "error",
            text: "Internal server Error",
          })
        );
    };
    const ParcelMemoTOsoldDialoge = () => {
      const [helperdata, setHelperdata] = useState([]);
      const [ButtonLoadng, setButtonLoadng] = useState(false);
      const [stoneDataDetail, setStoneDataDetail] = useState(null);
      const [CurrencyName, setCurrencyName] = useState(null);
      const swal = useSwalWrapper();

      // const { type, prid, trid } = useParams()
      useEffect(() => {
        let TMPOBJ = {
          pcs: bulkSelectrdstoneDataVal?.length,
          cts: bulkSelectrdstoneDataVal?.reduce(
            (acc, obj) => acc + obj.FL_KEPT_CTS,
            0
          ),
          price: bulkSelectrdstoneDataVal?.reduce(
            (acc, obj) => acc + obj.FL_SALERATE,
            0
          ),
        };
        setStoneDataDetail({
          ...TMPOBJ,
          price: TMPOBJ.price / TMPOBJ.pcs,
          amt: (TMPOBJ.price / TMPOBJ.pcs) * TMPOBJ.cts,
        });
      }, [bulkSelectrdstoneDataVal]);

      const handleSubmit = async (values, resetForm) => {
        // Handle form submission logic here
        if (values.term && values.FL_CURR_CODE && values.FL_CURR_CODE) {
          setButtonLoadng(true);
          // resetForm();
          // let fData = Data?.filter((st) => SelectedStone.includes(st.FL_STONE_ID))
          await jwtAuthAxios
            .post("transation/memoTosoldTransaction", {
              ...values,
              Party: prid,
              transactionType: type,
              StoneData: bulkSelectrdstoneDataVal.map((s) => ({
                ...s,
                STONE: s.FL_STONE_ID,
              })),
              isDetail: "Y",
              isMemo: "Y",
              trno: trid,
              intype: "POLISH-PARCEL",
            })
            .then((res) => {
              swal.fire({
                icon: "success",
                text: res.data.message,
              });
              resetForm();
              fetchtrdata();
              handleClose();
            })
            .catch((e) => {
              swal.fire({
                icon: "error",
                text: "Internal server Error",
              });
            })
            .finally(() => {
              setButtonLoadng(false);
            });
        } else {
          swal.fire({
            icon: "error",
            text: "Please Fill Detail",
          });
        }
      };
      const jumboco = useJumboAuth();
      const [initialValues, setInitialValues] = useState({
        shippingNumber: "",
        FL_BANK_CODE: "",
        term: "",
        shipBy: "",
        wat_per: helperdata?.TAX?.FL_TAX_PER || 0,
        ShipingCharge: 0,
        CertCharge: 0,
        OtherCharge: 0,
        Discount: 0,
        narration: "",
        is_p: false,
        FL_CURR_CODE: "2",
        FL_CONV_RATE: CurrData.FL_CONV_RATE,
      });
      useEffect(() => {
        setInitialValues({
          ...initialValues,
          wat_per: helperdata?.TAX?.FL_TAX_PER,
        });
      }, [helperdata]);
      useEffect(() => {
        jwtAuthAxios
          .get(
            `master/helper?paramsData=SHIPPEDBY&term=1&PVID=Sold&curr=1&tax=VAT_ON_SALES&leadgerdetail=22`
          )
          .then((res) => {
            setHelperdata(res.data?.data);
          })
          .catch((e) => {
            swal.fire({
              icon: "error",
              text: "Internal server Error",
            });
          });
        // fetchBasketdata();
      }, []);
      const Item = styled(Paper)(({ theme }) => ({
        backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
        ...theme.typography.body2,
        padding: theme.spacing(1),
        textAlign: "center",
        color: theme.palette.text.secondary,
      }));
      return (
        <Dialog
          open={bulkmemoDialoge}
          sx={{ minWidth: "650px" }}
          onClose={() => setBulkmemoDialoge(false)}
        >
          <DialogTitle>Sold Shipping Information</DialogTitle>
          <DialogContent>
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
            >
              {({ values, resetForm, setFieldValue, errors, touched }) => (
                // <Form onSubmit={handleSubmit} >
                <>
                  {" "}
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <InputLabel>Select Bank</InputLabel>
                      <Field
                        size="small"
                        name="FL_BANK_CODE"
                        InputLabel="Select Bank"
                        as={Select}
                        fullWidth
                      >
                        <MenuItem value="">Select Select Bank</MenuItem>
                        {helperdata?.leadgerdetail?.map((item) => (
                          <MenuItem value={item.ACODE}>{item.ANAME}</MenuItem>
                        ))}
                      </Field>
                      {errors.FL_BANK_CODE && (
                        <div className="error">{errors.FL_BANK_CODE}</div>
                      )}
                    </Grid>
                    <Grid item lg={6}>
                      <Field
                        name="FL_CURR_CODE"
                        as={TextField}
                        style={{ margin: "5px 0" }}
                        InputProps={{ size: "small" }}
                        InputLabelProps={{ size: "small" }}
                        select
                        label="Currency Type"
                        fullWidth
                      >
                        {helperdata?.CURR?.map((option) => (
                          <MenuItem
                            key={option.FL_CURRENCY_ID}
                            onClick={(e) => {
                              setCurrencyName(option.FL_CURRENCY_NAME);
                            }}
                            fname={option.FL_CURRENCY_NAME}
                            value={option.FL_CURRENCY_ID}
                          >
                            {option.FL_CURRENCY_NAME}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid item lg={6}>
                      <Field
                        name="FL_CONV_RATE"
                        as={TextField}
                        style={{ margin: "5px 0" }}
                        InputProps={{ size: "small" }}
                        InputLabelProps={{ size: "small" }}
                        type="number"
                        label="Conv Rate"
                        fullWidth
                      />
                    </Grid>
                  </Grid>
                  <Field
                    name="term"
                    as={TextField}
                    InputProps={{ size: "small" }}
                    InputLabelProps={{ size: "small" }}
                    style={{ margin: "5px 0" }}
                    select
                    label="Payment Term"
                    fullWidth
                  >
                    {helperdata?.TERM?.map((option) => (
                      <MenuItem
                        key={option.FL_TERM_CODE}
                        color="primary"
                        value={option.FL_TERM_CODE}
                      >
                        {option.FL_TERM_NAME}
                      </MenuItem>
                    ))}
                  </Field>
                  <Field
                    name="shipBy"
                    as={TextField}
                    style={{ margin: "5px 0" }}
                    InputProps={{ size: "small" }}
                    InputLabelProps={{ size: "small" }}
                    select
                    label="Ship By"
                    fullWidth
                  >
                    {helperdata?.SHIPPEDBY?.map((option) => (
                      <MenuItem
                        key={option.FL_PARA_VALUE}
                        value={option.FL_GPID}
                      >
                        {option.FL_PARA_VALUE}
                      </MenuItem>
                    ))}
                  </Field>
                  <Grid container columnSpacing={2}>
                    <Grid item lg={6}>
                      <Field
                        name="wat_per"
                        disabled={values.is_p != true}
                        as={TextField}
                        type="number"
                        min={"0"}
                        defaultValue={"0"}
                        style={{ margin: "5px 0" }}
                        InputProps={{ size: "small" }}
                        InputLabelProps={{ size: "small" }}
                        label="Vat Charge(%)"
                        fullWidth
                      />
                    </Grid>
                    <Grid item lg={6}>
                      <Field
                        name="ShipingCharge"
                        as={TextField}
                        type="number"
                        min={"0"}
                        defaultValue={"0"}
                        style={{ margin: "5px 0" }}
                        InputProps={{ size: "small" }}
                        InputLabelProps={{ size: "small" }}
                        label="Shiping Charge(AMT)"
                        fullWidth
                      />
                    </Grid>
                    <Grid item lg={6}>
                      <Field
                        name="CertCharge"
                        as={TextField}
                        type="number"
                        min={"0"}
                        defaultValue={"0"}
                        style={{ margin: "5px 0" }}
                        InputProps={{ size: "small" }}
                        InputLabelProps={{ size: "small" }}
                        label="Cert. Charge(AMT)"
                        fullWidth
                      />
                    </Grid>
                    <Grid item lg={6}>
                      <Field
                        name="OtherCharge"
                        as={TextField}
                        type="number"
                        min={"0"}
                        defaultValue={"0"}
                        style={{ margin: "5px 0" }}
                        InputProps={{ size: "small" }}
                        InputLabelProps={{ size: "small" }}
                        label="OtherCharge(AMT)"
                        fullWidth
                      />
                    </Grid>
                    <Grid item lg={6}>
                      <Field
                        name="Discount"
                        as={TextField}
                        type="number"
                        min={"0"}
                        defaultValue={"0"}
                        style={{ margin: "5px 0" }}
                        InputProps={{ size: "small" }}
                        InputLabelProps={{ size: "small" }}
                        label="Discount(-AMT)"
                        fullWidth
                      />
                    </Grid>
                    <Grid item lg={6}>
                      <Field
                        name="shippingNumber"
                        InputProps={{ size: "small" }}
                        InputLabelProps={{ size: "small" }}
                        as={TextField}
                        style={{ margin: "5px 0" }}
                        label="Shipping Number"
                        fullWidth
                      />
                    </Grid>
                  </Grid>
                  <InputLabel>Naration</InputLabel>
                  <Field
                    size="small"
                    component={TextareaAutosize}
                    name="narration"
                    label="Naration"
                    minRows={3}
                    onChange={(e) => setFieldValue("narration", e.target.value)}
                    style={{ width: "100%" }}
                    fullWidth
                  />
                  <Field
                    name="is_p"
                    render={({ field }) => (
                      <FormControlLabel
                        control={
                          <Checkbox
                            {...field}
                            onClick={() =>
                              !values.is_p
                                ? setFieldValue("wat_per", 0)
                                : setFieldValue(
                                    "wat_per",
                                    helperdata?.TAX?.FL_TAX_PER
                                  )
                            }
                            style={{ margin: "5px 0" }}
                            size="small"
                            // Add any other Checkbox props here
                          />
                        }
                        label="IS P"
                        fullWidth
                      />
                    )}
                  />
                  <Stack
                    direction="row"
                    divider={<Divider orientation="vertical" flexItem />}
                    spacing={2}
                    sx={{ mb: 1 }}
                  >
                    <Item>CTS = {stoneDataDetail?.cts?.toFixed(2) || 0.0}</Item>
                    {/* <Item>Total Amt =  {(stoneDataDetail.price || 0)*(stoneDataDetail.cts||0)}</Item> */}
                  </Stack>
                  <Stack
                    direction="row"
                    divider={<Divider orientation="vertical" flexItem />}
                    spacing={2}
                    sx={{ mb: 1 }}
                  >
                    <Item>
                      ShipingCharge ($AMT) = {values.ShipingCharge || 0}
                    </Item>
                    <Item>OtherCharge ($AMT) = {values.OtherCharge || 0}</Item>
                    <Item>CertCharge ($AMT) = {values.CertCharge || 0}</Item>
                    <Item>Disc($AMT) = (-{values.Discount || 0})</Item>
                  </Stack>
                  <Stack
                    direction="row"
                    divider={<Divider orientation="vertical" flexItem />}
                    spacing={2}
                    sx={{ mb: 1 }}
                  >
                    <Item>Price/cts($) = {stoneDataDetail?.price}</Item>
                    {/* <Item>Total Amt ($) = {((stoneDataDetail?.price + ((stoneDataDetail?.price * values.wat_per) / 100) + values.CertCharge + values.OtherCharge + values.ShipingCharge - values.Discount) * Number(stoneDataDetail?.cts))?.toFixed(2) || 0}</Item> */}
                    {/* <Item>Total Amt ($) = {(
                          ((stoneDataDetail?.price || 0) +
                          (((stoneDataDetail?.price || 0) * (values.wat_per || 0)) / 100) +
                          (values.CertCharge || 0) +
                          (values.OtherCharge || 0) +
                          (values.ShipingCharge || 0)) 
                        ) * -
                        (values.Discount || 0)}</Item> */}
                    <Item>
                      Total Amt ($) ={" "}
                      {Number(stoneDataDetail?.amt || 0) +
                        ((stoneDataDetail?.amt || 0) * (values.wat_per || 0)) /
                          100 +
                        (values.CertCharge || 0) +
                        (values.OtherCharge || 0) +
                        (values.ShipingCharge || 0) -
                        (values.Discount || 0)}
                    </Item>
                    <Item>
                      Total Amt ({CurrData?.CODE}) ={" "}
                      {(Number(stoneDataDetail?.amt || 0) +
                        ((stoneDataDetail?.amt || 0) * (values.wat_per || 0)) /
                          100 +
                        (values.CertCharge || 0) +
                        (values.OtherCharge || 0) +
                        (values.ShipingCharge || 0) -
                        (values.Discount || 0)) *
                        values.FL_CONV_RATE}
                    </Item>
                    {/* <Item>Total Amt ({CurrData?.CODE}) = {(((stoneDataDetail?.price + ((stoneDataDetail?.price * values.wat_per) / 100) + values.CertCharge + values.OtherCharge + values.ShipingCharge - values.Discount) * values.FL_CONV_RATE) * Number(stoneDataDetail?.cts))?.toFixed(2) || 0}</Item> */}
                  </Stack>
                  <LoadingButton
                    loading={ButtonLoadng}
                    variant="contained"
                    color="primary"
                    sx={{ display: "block", marginLeft: "auto", mt: 3 }}
                    disabled={!values.FL_BANK_CODE}
                    onClick={() => handleSubmit(values, resetForm)}
                  >
                    Sold
                  </LoadingButton>
                </>
                // </Form>
              )}
            </Formik>
          </DialogContent>
        </Dialog>
      );
    };
    useEffect(() => {
      // console.log();
      setdisabledButton({
        ...disabledButton,
        proceedmemotosold:
          bulkSelectrdstoneDataVal.map((s) => s.FL_KEPT_CTS).indexOf(0) != -1,
      });
    }, [bulkSelectrdstoneDataVal]);
    if (MData == null) {
      return <TableSkeleton cols={6} rows={5} />;
    } else
      return (
        <>
          {prid && (
            <Div sx={{ width: "100%" }}>
              {type == 33 && (
                <Stack
                  direction="row"
                  spacing={2}
                  sx={{
                    justifyContent: "space-between",
                    alignItems: "center",
                    mb: 3,
                  }}
                >
                  <Div>
                    {processType == null ? (
                      <>
                        <Button
                          variant="contained"
                          disabled={bulkSelectrdlot.length < 1}
                          onClick={handleMemoReturn}
                          color="primary"
                        >
                          Memo Return
                        </Button>
                        <Button
                          variant="contained"
                          disabled={bulkSelectrdlot.length < 1}
                          onClick={handleMemoToSale}
                          sx={{ mx: 1 }}
                          color="primary"
                        >
                          Memo To Sold
                        </Button>
                        {/* <Button variant='contained' disabled={SelectedStone?.length <= 0} onClick={() => { setdelctendStoneDetail(); setOpen(true) }} sx={{ mx: 1 }} color='primary'>Memo To Sold</Button> */}
                        {apirefdatagridMain && (
                          <Button
                            variant="contained"
                            onClick={getSelectedCellValues}
                            color="primary"
                          >
                            Save Memo
                          </Button>
                        )}
                      </>
                    ) : processType == "mts" ? (
                      <>
                        <Button
                          variant="contained"
                          onClick={() => setProcessType(null)}
                          color="primary"
                        >
                          Back To Main
                        </Button>
                        <Button
                          variant="contained"
                          disabled={disabledButton?.proceedmemotosold}
                          sx={{ ml: 1 }}
                          onClick={() => {
                            setBulkmemoDialoge(true);
                          }}
                          color="primary"
                        >
                          Proceed To Sell
                        </Button>
                      </>
                    ) : (
                      <>
                        <Button
                          variant="contained"
                          onClick={() => setProcessType(null)}
                          color="primary"
                        >
                          Back To Main
                        </Button>
                        <Button
                          variant="contained"
                          sx={{ ml: 1 }}
                          onClick={returnMemoBulkHandler}
                          color="primary"
                        >
                          Return Memo
                        </Button>
                      </>
                    )}
                  </Div>
                  <Div sx={{ display: "flex", alignItems: "center" }}>
                    <Button
                      variant="contained"
                      sx={{ mr: 1 }}
                      disabled={!trid}
                      onClick={() => {
                        window.open(
                          BACKEND_APP_URL + "rp/GenerateMemo?memono=" + trid
                        );
                      }}
                    >
                      Download Memo
                    </Button>
                    <TextField
                      label="Conv Rate"
                      id="outlined-start-adornment"
                      size="small"
                      sx={{
                        m: 1,
                        width: "25ch",
                        display: "block",
                        marginLeft: "auto",
                      }}
                      value={CurrData?.FL_CONV_RATE}
                      type="number"
                      onInput={(e) =>
                        setCurrData({
                          ...CurrData,
                          FL_CONV_RATE: e.target.value,
                        })
                      }
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            {CurrData?.CODE}
                          </InputAdornment>
                        ),
                      }}
                    />
                    {/* <BulkMemoReturnHandler /> */}
                  </Div>
                </Stack>
              )}
            </Div>
          )}
          <Paper>
            {processType == "mr" ? (
              <DataGrid
                rows={bulkSelectrdstoneDataVal || []}
                columns={memoReturnColumn}
                apiRef={apirefdatagrid}
                pageSize={5}
                onRowSelectionModelChange={(e) => setBulkSelectrdlot(e)}
                getRowId={(r) => r?.FL_STONE_ID}
                rowsPerPageOptions={[5, 10, 20]}
                disableRowSelectionOnClick
                density="compact"
                onCellEditStop={handleCellEdit}
              />
            ) : processType == "mts" ? (
              <>
                <DataGrid
                  rows={bulkSelectrdstoneDataVal || []}
                  columns={memoToSoldColumn}
                  apiRef={apirefdatagridmts}
                  pageSize={5}
                  onRowSelectionModelChange={(e) => setBulkSelectrdlot(e)}
                  getRowId={(r) => r?.FL_STONE_ID}
                  rowsPerPageOptions={[5, 10, 20]}
                  disableRowSelectionOnClick
                  density="compact"
                  onCellEditStop={handleCellEditMTS}
                />
                <ParcelMemoTOsoldDialoge />
              </>
            ) : (
              <DataGrid
                rows={MData || []}
                columns={column}
                apiRef={apirefdatagridMain}
                pageSize={5}
                onRowSelectionModelChange={(e) => setBulkSelectrdlot(e)}
                getRowId={(r) => r?.FL_STONE_ID}
                rowsPerPageOptions={[5, 10, 20]}
                disableRowSelectionOnClick
                checkboxSelection
                density="compact"
                // onProcessRowUpdateError={(e, v) => console.log(e, v)}
                // editMode="cell"
                // onCellEditStop={handleCellEditMain}
                // processRowUpdate={(updatedRow, originalRow) => console.log(updatedRow)}
              />
            )}
          </Paper>
        </>
      );
  };
  const [helperdata, setHelperdata] = useState([]);

  useEffect(() => {
    jwtAuthAxios
      .get(
        `master/helper?paramsData=SHIPPEDBY&term=1&PVID=Sold&curr=1&tax=VAT_ON_SALES&leadgerdetail=22`
      )
      .then((res) => {
        setHelperdata(res.data?.data);
        // setWatper(res.data?.data?.TAX?.FL_TAX_PER)
      })
      .catch((e) => {
        swal.fire({
          icon: "error",
          text: "Internal server Error",
        });
      });
    // fetchBasketdata();
  }, []);
  const PartransactionSingle = () => {
    return (
      <>
        {prid && (
          <Div sx={{ width: "100%" }}>
            {type == 33 && (
              <Stack
                direction="row"
                spacing={2}
                sx={{
                  justifyContent: "end",
                  alignItems: "center",
                  mb: 3,
                }}
              >
                <Button
                  variant="contained"
                  sx={{ mr: 1 }}
                  disabled={!trid}
                  onClick={() => {
                    window.open(
                      BACKEND_APP_URL + "rp/GenerateMemo?memono=" + trid
                    );
                  }}
                >
                  Download Memo
                </Button>
                <TextField
                  label="Conv Rate"
                  id="outlined-start-adornment"
                  size="small"
                  sx={{
                    m: 1,
                    width: "25ch",
                    display: "block",
                    marginLeft: "auto",
                  }}
                  value={CurrData?.FL_CONV_RATE}
                  type="number"
                  onInput={(e) =>
                    setCurrData({ ...CurrData, FL_CONV_RATE: e.target.value })
                  }
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        {CurrData?.CODE}
                      </InputAdornment>
                    ),
                  }}
                />
                <Button
                  variant="contained"
                  disabled={SelectedStone?.length <= 0}
                  onClick={memoReturnHandler}
                  color="primary"
                >
                  Memo Return
                </Button>
                <Button
                  variant="contained"
                  disabled={SelectedStone?.length <= 0}
                  onClick={() => {
                    setdelctendStoneDetail();
                    setOpen(true);
                  }}
                  sx={{ ml: 1 }}
                  color="primary"
                >
                  Memo To Sold
                </Button>
                <Button
                  variant="contained"
                  disabled={SelectedStone?.length <= 0}
                  color="primary"
                >
                  Save Memo
                </Button>
              </Stack>
            )}
            {MData == null && trid != null ? (
              <TableSkeleton />
            ) : MData?.length > 0 ? (
              <TableContainer component={Paper}>
                <Table
                  sx={{ minWidth: 650 }}
                  size="small"
                  aria-label="Status table"
                >
                  <TableHead>
                    <TableRow>
                      <TableCell>
                        <Checkbox
                          checked={MData?.length == SelectedStone?.length}
                          onClick={(e) => {
                            if (e.target.checked) {
                              let FilterMData = MData?.filter(
                                (row, index) => row.STATUS == "MEMO"
                              );
                              let stonMData = FilterMData?.map(
                                (row, index) => row.FL_STONE_ID
                              );
                              stonMData
                                ? setSelectedStone(stonMData)
                                : setSelectedStone([]);
                            } else {
                              setSelectedStone([]);
                            }
                          }}
                        />
                      </TableCell>
                      <TableCell align="center">STATUS</TableCell>
                      <TableCell align="center">StoneId</TableCell>
                      <TableCell align="center">Lab</TableCell>
                      <TableCell align="center">ReportNO</TableCell>
                      <TableCell align="center">Shape</TableCell>
                      <TableCell align="center">CARATS</TableCell>
                      <TableCell align="center">Color</TableCell>
                      <TableCell align="center">Clarity</TableCell>
                      <TableCell align="center">RapPrice($)</TableCell>
                      <TableCell align="center">Disc</TableCell>
                      <TableCell align="center">Amt\cts</TableCell>
                      <TableCell align="center">Sale Amt($)</TableCell>
                      <TableCell align="center">
                        Sale Amt({jumboco?.curr?.cd})
                      </TableCell>
                      <TableCell align="center">Kept</TableCell>
                      <TableCell align="center">Return</TableCell>
                    </TableRow>
                  </TableHead>
                  {MData?.map((stone, t) => (
                    <TableBody
                      sx={{
                        backgroundColor: `${
                          stone.FL_RET_CTS == stone.CARATS
                            ? "#e7314521"
                            : stone.FL_KEPT_CTS == stone.CARATS
                            ? "#00800017"
                            : "initial"
                        }`,
                      }}
                      key={t}
                    >
                      <TableCell>
                        <Checkbox
                          disabled={stone.STATUS != "MEMO"}
                          checked={SelectedStone.includes(stone.FL_STONE_ID)}
                          onClick={() => {
                            handleStoneSelect(stone.FL_STONE_ID);
                          }}
                        />
                      </TableCell>
                      <TableCell align="center">{stone.STATUS}</TableCell>
                      <TableCell align="center">{stone.FL_STONE_ID}</TableCell>
                      <TableCell align="center">{stone.FL_LAB}</TableCell>
                      <TableCell align="center">
                        {stone.FL_CERTIFICATENO}
                      </TableCell>
                      <TableCell align="center">{stone.SHAPE}</TableCell>
                      <TableCell align="center">{stone.CARATS}</TableCell>
                      <TableCell align="center">{stone.COLOR}</TableCell>
                      <TableCell align="center">{stone.FL_CLARITY}</TableCell>
                      <TableCell align="center">
                        {stone.FL_RAP_PRICE_US}
                      </TableCell>
                      <TableCell align="center">
                        {stone.STATUS == "MEMO" ? (
                          <TextField
                            size="small"
                            type="number"
                            id={`input-0-${t}`}
                            min={0}
                            max={100}
                            sx={{ minWidth: 150 }}
                            onBlur={(e) => handlediscChang(e, stone, 0)}
                            defaultValue={Number(stone.MDISC).toFixed(2)}
                          />
                        ) : (
                          stone.MDISC?.toFixed(2)
                        )}
                      </TableCell>
                      <TableCell align="center">
                        {stone.STATUS == "MEMO" ? (
                          <TextField
                            size="small"
                            type="number"
                            id={`input-1-${t}`}
                            min={0}
                            sx={{ minWidth: 150 }}
                            onBlur={(e) => handlediscChang(e, stone, 1)}
                            defaultValue={Number(
                              stone.mPrice ||
                                stone.FL_RAP_PRICE_US -
                                  (stone.FL_RAP_PRICE_US * stone.MDISC) / 100
                            ).toFixed(2)}
                          />
                        ) : (
                          stone.FL_SALERATE?.toFixed(2)
                        )}
                      </TableCell>
                      <TableCell align="center">
                        {stone.STATUS == "MEMO" ? (
                          <TextField
                            size="small"
                            type="number"
                            id={`input-2-${t}`}
                            min={0}
                            sx={{ minWidth: 150 }}
                            onBlur={(e) => handlediscChang(e, stone, 2)}
                            defaultValue={Number(
                              stone.mamt ||
                                (stone.FL_RAP_PRICE_US -
                                  (stone.FL_RAP_PRICE_US * stone.MDISC) / 100) *
                                  stone.CARATS
                            ).toFixed(2)}
                          />
                        ) : (
                          stone.FL_AMT1?.toFixed(2)
                        )}
                      </TableCell>
                      <TableCell align="center">
                        {(
                          (CurrData?.FL_CONV_RATE || 1) *
                          Number(
                            stone.mamt ||
                              (stone.FL_RAP_PRICE_US -
                                (stone.FL_RAP_PRICE_US * stone.MDISC) / 100) *
                                stone.CARATS
                          )
                        ).toFixed(2)}
                      </TableCell>
                      <TableCell align="center">
                        {stone.FL_KEPT_CTS == stone.CARATS ? (
                          <CheckBoxOutlinedIcon />
                        ) : (
                          "-"
                        )}
                      </TableCell>
                      <TableCell align="center">
                        {stone.FL_RET_CTS == stone.CARATS ? (
                          <CheckBoxOutlinedIcon />
                        ) : (
                          "-"
                        )}
                      </TableCell>
                    </TableBody>
                  ))}
                </Table>
              </TableContainer>
            ) : (
              <NoDataPlaceholder />
            )}
            <ShippingFormMemoTOSOLDDialog
              CurrData={CurrData}
              helperdata={helperdata}
              SelectedStoneDetail={SelectedStoneDetail}
              selectedMemoNo={trid}
              Data={MData}
              open={open}
              handleClose={handleClose}
              callBack={fetchtrdata}
              SelectedStone={SelectedStone}
              userSelectedParty={prid}
            />
          </Div>
        )}
      </>
    );
  };

  const Jewelrytransaction = () => {
    return (
      <>
        {prid && (
          <Div sx={{ width: "100%" }}>
            {type == 33 && (
              <Stack
                direction="row"
                spacing={2}
                sx={{
                  justifyContent: "end",
                  alignItems: "center",
                  mb: 3,
                }}
              >
                <Button
                  variant="contained"
                  sx={{ mr: 1 }}
                  disabled={!trid}
                  onClick={() => {
                    window.open(
                      BACKEND_APP_URL + "rp/GenerateMemo?memono=" + trid
                    );
                  }}
                >
                  Download Memo
                </Button>
                <TextField
                  label="Conv Rate"
                  id="outlined-start-adornment"
                  size="small"
                  sx={{
                    m: 1,
                    width: "25ch",
                    display: "block",
                    marginLeft: "auto",
                  }}
                  value={CurrData?.FL_CONV_RATE}
                  type="number"
                  onInput={(e) =>
                    setCurrData({ ...CurrData, FL_CONV_RATE: e.target.value })
                  }
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        {CurrData?.CODE}
                      </InputAdornment>
                    ),
                  }}
                />
                <Button
                  variant="contained"
                  disabled={SelectedStone?.length <= 0}
                  onClick={memoReturnHandler}
                  color="primary"
                >
                  Memo Return
                </Button>
                <Button
                  variant="contained"
                  disabled={SelectedStone?.length <= 0}
                  onClick={() => {
                    setdelctendStoneDetail();
                    setOpen(true);
                  }}
                  sx={{ ml: 1 }}
                  color="primary"
                >
                  Memo To Sold
                </Button>
              </Stack>
            )}
            {MData == null && trid != null ? (
              <TableSkeleton />
            ) : MData?.length > 0 ? (
              <TableContainer component={Paper}>
                <Table
                  sx={{ minWidth: 650 }}
                  size="small"
                  aria-label="Status table"
                >
                  <TableHead>
                    <TableRow>
                      <TableCell>
                        <Checkbox
                          checked={MData?.length == SelectedStone?.length}
                          onClick={(e) => {
                            if (e.target.checked) {
                              let FilterMData = MData?.filter(
                                (row, index) => row.STATUS != "MEMO"
                              );
                              let stonMData = FilterMData?.map(
                                (row, index) => row.FL_STONE_ID
                              );
                              stonMData
                                ? setSelectedStone(stonMData)
                                : setSelectedStone([]);
                            } else {
                              setSelectedStone([]);
                            }
                          }}
                        />
                      </TableCell>
                      <TableCell align="center">Item Code</TableCell>
                      <TableCell align="center">Catgory</TableCell>
                      <TableCell align="center">Quality</TableCell>
                      <TableCell align="center">Gross Wt</TableCell>
                      <TableCell align="center">Diam Cts</TableCell>
                      <TableCell align="center">Diam Pcs</TableCell>
                      <TableCell align="center">Status</TableCell>
                      <TableCell align="center">Amount1</TableCell>
                      <TableCell align="center">Amount2</TableCell>
                      <TableCell align="center">Kept</TableCell>
                      <TableCell align="center">Return</TableCell>
                    </TableRow>
                  </TableHead>

                  {MData?.map((stone, t) => (
                    <TableBody
                      sx={{
                        backgroundColor: `${
                          stone.FL_RET_CTS == stone.CARATS
                            ? "#e7314521"
                            : stone.FL_KEPT_CTS == stone.CARATS
                            ? "#00800017"
                            : "initial"
                        }`,
                      }}
                      key={t}
                    >
                      <TableCell>
                        <Checkbox
                          disabled={
                            (stone.STATUS == "MEMO" &&
                              stone.FL_KEPT_CTS == stone.CARATS) ||
                            stone.FL_RET_CTS == stone.CARATS
                          }
                          checked={SelectedStone.includes(stone.FL_STONE_ID)}
                          onClick={() => {
                            handleStoneSelect(stone.FL_STONE_ID);
                          }}
                        />
                      </TableCell>
                      <TableCell align="center">{stone.FL_ITEM_CODE}</TableCell>
                      <TableCell align="center">{stone.FL_CATGORY}</TableCell>
                      <TableCell align="center">{stone.FL_QUALITY}</TableCell>
                      <TableCell align="center">{stone.FL_GROSS_WT}</TableCell>
                      <TableCell align="center">{stone.FL_DIAM_CTS}</TableCell>
                      <TableCell align="center">{stone.FL_DIAM_PCS}</TableCell>
                      <TableCell align="center">{stone.FL_STATUS}</TableCell>
                      <TableCell align="center">
                        {(stone?.FL_AMT2 / CurrData?.FL_CONV_RATE).toFixed(2)}
                      </TableCell>

                      <TableCell align="center">
                        <TextField
                          size="small"
                          type="number"
                          id={`input-1-${t}`}
                          min={0}
                          disabled={
                            stone.FL_KEPT_CTS == stone.CARATS ||
                            stone.FL_RET_CTS == stone.CARATS
                          }
                          sx={{ minWidth: 150 }}
                          onBlur={(e) => handlediscChang(e, stone, 3)}
                          defaultValue={Number(stone.FL_AMT2).toFixed(2)}
                        />
                      </TableCell>
                      <TableCell align="center">
                        {stone.FL_KEPT_CTS == stone.CARATS ? (
                          <CheckBoxOutlinedIcon />
                        ) : (
                          "-"
                        )}
                      </TableCell>
                      <TableCell align="center">
                        {stone.FL_RET_CTS == stone.CARATS ? (
                          <CheckBoxOutlinedIcon />
                        ) : (
                          "-"
                        )}
                      </TableCell>
                    </TableBody>
                  ))}
                </Table>
              </TableContainer>
            ) : (
              <NoDataPlaceholder />
            )}
            <JewelyFormMemoTOSOLDDialog
              CurrData={CurrData}
              helperdata={helperdata}
              SelectedStoneDetail={SelectedStoneDetail}
              selectedMemoNo={trid}
              Data={MData}
              open={open}
              handleClose={handleClose}
              callBack={fetchtrdata}
              SelectedStone={SelectedStone}
              userSelectedParty={prid}
            />
          </Div>
        )}
      </>
    );
  };

  return CurrData?.FL_DIAMOND_TYPE == "POLISH-SINGLE" ? (
    <PartransactionSingle />
  ) : CurrData?.FL_DIAMOND_TYPE == "JEWELRY" ? (
    <Jewelrytransaction />
  ) : (
    <PolishParcelTransactionS />
  );
}

const ShippingFormMemoTOSOLDDialog = ({
  CurrData,
  helperdata,
  SelectedStoneDetail,
  SelectedStone,
  Data,
  userSelectedParty,
  open,
  handleClose,
  callBack,
  selectedMemoNo,
}) => {
  const { type, trid } = useParams();

  const [ButtonLoadng, setButtonLoadng] = useState(false);
  const [stoneDataDetail, setStoneDataDetail] = useState({
    pcs: 0,
    cts: 0,
    rap: 0,
    disc: 0,
  });
  const [CurrencyName, setCurrencyName] = useState(null);
  const swal = useSwalWrapper();
  // const { type, prid, trid } = useParams()
  // useEffect(() => {
  //   let TMPOBJ = {
  //     pcs: SelectedStoneDetail?.length,
  //     cts: SelectedStoneDetail?.reduce((acc, obj) => acc + obj.CARATS, 0),
  //     disc: ((SelectedStoneDetail?.reduce((acc, obj) => acc + Number(obj.MDISC), 0)) / SelectedStoneDetail?.length),
  //     rap: (SelectedStoneDetail?.reduce((acc, obj) => acc + obj.RAP_PRICE, 0) / SelectedStoneDetail?.length)
  //   }
  //   console.log(Data);
  //   setStoneDataDetail({ ...TMPOBJ, price: (TMPOBJ?.rap - ((TMPOBJ?.rap * TMPOBJ?.disc) / 100)) })
  // }, [SelectedStoneDetail, Data])
  useEffect(() => {
    if (SelectedStoneDetail) {
      // let ndata = SelectedStone?.flatMap((stone) =>
      //   Stoneresultdata?.filter((s) => s.STONE === stone)
      // );
      // console.log(ndata);
      let tempCal = { pcs: 0, cts: 0, rap: 0, disc: 0, amt2: 0, amt1: 0 };
      SelectedStoneDetail?.forEach((sdata) => {
        // console.log(sdata);
        tempCal = {
          pcs: tempCal.pcs + 1,
          cts: tempCal.cts + sdata.CARATS,
          rap: Number(tempCal.rap) + Number(sdata.RAP_PRICE),
          disc: Number(tempCal.disc) + Number(sdata.MDISC),
          amt1:
            Number(tempCal.amt1) +
            Number(
              sdata.MDISCS ||
                ((sdata.RAP_PRICE * (100 - sdata.MDISC)) / 100) * sdata.CARATS
            ),
        };
      });
      // console.log(tempCal);
      tempCal = {
        pcs: tempCal.pcs,
        amt1: tempCal.amt1,
        cts: tempCal.cts,
        rap: Number(tempCal.rap) / Number(tempCal.pcs),
        disc: Number(tempCal.disc) / Number(tempCal.pcs),
      };
      // alert(tempCal.amt1+'-'+tempCal.cts)
      tempCal = {
        ...tempCal,
        price: tempCal.amt1 / tempCal.cts, //Number(tempCal.rap) - (tempCal.rap * tempCal.disc / 100)
      };
      // console.log(tempCal);
      tempCal.pcs != 0 && setStoneDataDetail({ ...tempCal, amt: tempCal.amt1 });
    }
  }, [SelectedStoneDetail, Data]);
  const handleSubmit = async (values, resetForm) => {
    // Handle form submission logic here
    if (values.term && values.FL_CURR_CODE && values.FL_CURR_CODE) {
      setButtonLoadng(true);
      // resetForm();
      // let fData = Data?.filter((st) => SelectedStone.includes(st.FL_STONE_ID))
      await jwtAuthAxios
        .post("transation/memoTosoldTransaction", {
          ...values,
          Party: userSelectedParty,
          transactionType: helperdata.PVID,
          StoneData: SelectedStoneDetail,
          isDetail: "Y",
          isMemo: "Y",
          trno: selectedMemoNo,
        })
        .then((res) => {
          swal.fire({
            icon: "success",
            text: res.data.message,
          });
          resetForm();
          callBack();
          handleClose();
        })
        .catch((e) => {
          swal.fire({
            icon: "error",
            text: "Internal server Error",
          });
        })
        .finally(() => {
          setButtonLoadng(false);
        });
    } else {
      swal.fire({
        icon: "error",
        text: "Please Fill Detail",
      });
    }
  };
  const jumboco = useJumboAuth();
  // const [watper,setWatper]=useState(0)
  const [initialValues, setInitialValues] = useState({
    shippingNumber: "",
    term: "",
    shipBy: "",
    wat_per: helperdata?.TAX?.FL_TAX_PER,
    ShipingCharge: 0,
    CertCharge: 0,
    narration: "",
    OtherCharge: 0,
    is_p: false,
    Discount: 0,
    FL_CURR_CODE: "2",
    FL_CONV_RATE: CurrData.FL_CONV_RATE,
  });
  useEffect(() => {
    setInitialValues({
      ...initialValues,
      wat_per: helperdata?.TAX?.FL_TAX_PER,
    });
  }, [helperdata]);
  // useEffect(() => {
  //   alert(watper)
  // }, [watper]);

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary,
  }));
  return (
    <Dialog open={open} sx={{ minWidth: "650px" }} onClose={handleClose}>
      <DialogTitle>Sold Shipping Information</DialogTitle>
      <DialogContent>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ values, resetForm, setFieldValue, errors, touched }) => (
            // <Form onSubmit={handleSubmit} >
            <>
              {" "}
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <InputLabel>Select Bank</InputLabel>
                  <Field
                    size="small"
                    name="FL_BANK_CODE"
                    InputLabel="Select Bank"
                    as={Select}
                    fullWidth
                  >
                    <MenuItem value="">Select Select Bank</MenuItem>
                    {helperdata?.leadgerdetail?.map((item) => (
                      <MenuItem value={item.ACODE}>{item.ANAME}</MenuItem>
                    ))}
                  </Field>
                  {errors.FL_BANK_CODE && touched.FL_BANK_CODE && (
                    <div className="error">{errors.FL_BANK_CODE}</div>
                  )}
                </Grid>
                <Grid item lg={6}>
                  <Field
                    name="FL_CURR_CODE"
                    as={TextField}
                    style={{ margin: "5px 0" }}
                    InputProps={{ size: "small" }}
                    InputLabelProps={{ size: "small" }}
                    select
                    label="Currency Type"
                    fullWidth
                  >
                    {helperdata?.CURR?.map((option) => (
                      <MenuItem
                        key={option.FL_CURRENCY_ID}
                        onClick={(e) => {
                          setCurrencyName(option.FL_CURRENCY_NAME);
                        }}
                        fname={option.FL_CURRENCY_NAME}
                        value={option.FL_CURRENCY_ID}
                      >
                        {option.FL_CURRENCY_NAME}
                      </MenuItem>
                    ))}
                  </Field>
                </Grid>
                <Grid item lg={6}>
                  <Field
                    name="FL_CONV_RATE"
                    as={TextField}
                    style={{ margin: "5px 0" }}
                    InputProps={{ size: "small" }}
                    InputLabelProps={{ size: "small" }}
                    type="number"
                    label="Conv Rate"
                    fullWidth
                  />
                </Grid>
              </Grid>
              <Field
                name="term"
                as={TextField}
                InputProps={{ size: "small" }}
                InputLabelProps={{ size: "small" }}
                style={{ margin: "5px 0" }}
                select
                label="Payment Term"
                fullWidth
              >
                {helperdata?.TERM?.map((option) => (
                  <MenuItem
                    key={option.FL_TERM_CODE}
                    color="primary"
                    value={option.FL_TERM_CODE}
                  >
                    {option.FL_TERM_NAME}
                  </MenuItem>
                ))}
              </Field>
              <Field
                name="shipBy"
                as={TextField}
                style={{ margin: "5px 0" }}
                InputProps={{ size: "small" }}
                InputLabelProps={{ size: "small" }}
                select
                label="Ship By"
                fullWidth
              >
                {helperdata?.SHIPPEDBY?.map((option) => (
                  <MenuItem key={option.FL_PARA_VALUE} value={option.FL_GPID}>
                    {option.FL_PARA_VALUE}
                  </MenuItem>
                ))}
              </Field>
              <Grid container columnSpacing={2}>
                <Grid item lg={6}>
                  <Field
                    name="wat_per"
                    disabled={values.is_p == true}
                    as={TextField}
                    defaultValue={"0"}
                    type="number"
                    min={"0"}
                    style={{ margin: "5px 0" }}
                    InputProps={{ size: "small" }}
                    InputLabelProps={{ size: "small" }}
                    label="Vat Charge(%)"
                    fullWidth
                  />
                </Grid>
                <Grid item lg={6}>
                  <Field
                    name="ShipingCharge"
                    as={TextField}
                    type="number"
                    min={"0"}
                    defaultValue={"0"}
                    style={{ margin: "5px 0" }}
                    InputProps={{ size: "small" }}
                    InputLabelProps={{ size: "small" }}
                    label="Shiping Charge(AMT)"
                    fullWidth
                  />
                </Grid>
                <Grid item lg={6}>
                  <Field
                    name="CertCharge"
                    as={TextField}
                    type="number"
                    min={"0"}
                    defaultValue={"0"}
                    style={{ margin: "5px 0" }}
                    InputProps={{ size: "small" }}
                    InputLabelProps={{ size: "small" }}
                    label="Cert. Charge(AMT)"
                    fullWidth
                  />
                </Grid>
                <Grid item lg={6}>
                  <Field
                    name="OtherCharge"
                    as={TextField}
                    type="number"
                    min={"0"}
                    defaultValue={"0"}
                    style={{ margin: "5px 0" }}
                    InputProps={{ size: "small" }}
                    InputLabelProps={{ size: "small" }}
                    label="OtherCharge(AMT)"
                    fullWidth
                  />
                </Grid>
                <Grid item lg={6}>
                  <Field
                    name="Discount"
                    as={TextField}
                    type="number"
                    min={"0"}
                    defaultValue={"0"}
                    style={{ margin: "5px 0" }}
                    InputProps={{ size: "small" }}
                    InputLabelProps={{ size: "small" }}
                    label="Discount(-AMT)"
                    fullWidth
                  />
                </Grid>
                <Grid item lg={6}>
                  <Field
                    name="shippingNumber"
                    InputProps={{ size: "small" }}
                    InputLabelProps={{ size: "small" }}
                    as={TextField}
                    style={{ margin: "5px 0" }}
                    label="Shipping Number"
                    fullWidth
                  />
                </Grid>
              </Grid>
              <InputLabel>Naration</InputLabel>
              <Field
                size="small"
                component={TextareaAutosize}
                name="narration"
                label="Naration"
                minRows={3}
                onChange={(e) => setFieldValue("narration", e.target.value)}
                style={{ width: "100%" }}
                fullWidth
              />
              <Field
                name="is_p"
                render={({ field }) => (
                  <FormControlLabel
                    control={
                      <Checkbox
                        {...field}
                        onClick={() =>
                          !values.is_p
                            ? setFieldValue("wat_per", 0)
                            : setFieldValue(
                                "wat_per",
                                helperdata?.TAX?.FL_TAX_PER
                              )
                        }
                        style={{ margin: "5px 0" }}
                        size="small"
                        // Add any other Checkbox props here
                      />
                    }
                    label="IS P"
                    fullWidth
                  />
                )}
              />
              <Stack
                direction="row"
                divider={<Divider orientation="vertical" flexItem />}
                spacing={2}
                sx={{ mb: 1 }}
              >
                <Item>Pcs {stoneDataDetail?.pcs || 0}</Item>
                <Item>CTS {stoneDataDetail?.cts?.toFixed(2) || 0.0}</Item>
                <Item>Rap {stoneDataDetail?.rap.toFixed(2) || 0}</Item>
                <Item>Disc% {stoneDataDetail?.disc?.toFixed(2) || 0}</Item>
                <Item>vat% {values.wat_per || 0}</Item>
              </Stack>
              <Stack
                direction="row"
                divider={<Divider orientation="vertical" flexItem />}
                spacing={2}
                sx={{ mb: 1 }}
              >
                <Item>ShipingCharge ($AMT) = {values.ShipingCharge || 0}</Item>
                <Item>OtherCharge ($AMT) = {values.OtherCharge || 0}</Item>
                <Item>CertCharge ($AMT) = {values.CertCharge || 0}</Item>
                <Item>Disc($AMT) = (-{values.Discount || 0})</Item>
              </Stack>
              <Stack
                direction="row"
                divider={<Divider orientation="vertical" flexItem />}
                spacing={2}
                sx={{ mb: 1 }}
              >
                <Item>
                  Price/cts($) ={" "}
                  {(
                    stoneDataDetail?.price +
                    (stoneDataDetail?.price * values.wat_per) / 100
                  )?.toFixed(2) || 0}
                </Item>
                {/* <Item>Total Amt ($) = {((stoneDataDetail?.price + ((stoneDataDetail?.price * values.wat_per) / 100) + values.CertCharge + values.OtherCharge + values.ShipingCharge - values.Discount) * Number(stoneDataDetail?.cts))?.toFixed(2) || 0}</Item> */}
                {/* <Item>Total Amt ($) = {(
                      ((stoneDataDetail?.price || 0) +
                      (((stoneDataDetail?.price || 0) * (values.wat_per || 0)) / 100) +
                      (values.CertCharge || 0) +
                      (values.OtherCharge || 0) +
                      (values.ShipingCharge || 0)) 
                    ) * -
                    (values.Discount || 0)}</Item> */}
                <Item>
                  Total Amt ($) ={" "}
                  {(
                    Number(stoneDataDetail?.price || 0) *
                      Number(stoneDataDetail?.cts || 0) +
                    (Number(stoneDataDetail?.price || 0) *
                      Number(stoneDataDetail?.cts || 0) *
                      (values.wat_per || 0)) /
                      100 +
                    (values.CertCharge || 0) +
                    (values.OtherCharge || 0) +
                    (values.ShipingCharge || 0) -
                    (values.Discount || 0)
                  )?.toFixed(2)}
                </Item>
                <Item>
                  Total Amt ({CurrData?.CODE}) ={" "}
                  {(
                    (Number(stoneDataDetail?.price || 0) *
                      Number(stoneDataDetail?.cts || 0) +
                      (Number(stoneDataDetail?.price || 0) *
                        Number(stoneDataDetail?.cts || 0) *
                        (values.wat_per || 0)) /
                        100 +
                      (values.CertCharge || 0) +
                      (values.OtherCharge || 0) +
                      (values.ShipingCharge || 0) -
                      (values.Discount || 0)) *
                    values.FL_CONV_RATE
                  )?.toFixed(2)}
                </Item>
                {/* <Item>Total Amt ({CurrData?.CODE}) = {(((stoneDataDetail?.price + ((stoneDataDetail?.price * values.wat_per) / 100) + values.CertCharge + values.OtherCharge + values.ShipingCharge - values.Discount) * values.FL_CONV_RATE) * Number(stoneDataDetail?.cts))?.toFixed(2) || 0}</Item> */}
              </Stack>
              <LoadingButton
                loading={ButtonLoadng}
                variant="contained"
                color="primary"
                sx={{ display: "block", marginLeft: "auto", mt: 3 }}
                disabled={!values.FL_BANK_CODE}
                onClick={() => handleSubmit(values, resetForm)}
              >
                Sold
              </LoadingButton>
            </>
            // </Form>
          )}
        </Formik>
      </DialogContent>
    </Dialog>
  );
};

const JewelyFormMemoTOSOLDDialog = ({
  CurrData,
  helperdata,
  SelectedStoneDetail,
  SelectedStone,
  Data,
  userSelectedParty,
  open,
  handleClose,
  callBack,
  selectedMemoNo,
}) => {
  const { type, trid } = useParams();

  const [ButtonLoadng, setButtonLoadng] = useState(false);
  const [stoneDataDetail, setStoneDataDetail] = useState({
    pcs: 0,
    cts: 0,
    rap: 0,
    disc: 0,
  });
  const [CurrencyName, setCurrencyName] = useState(null);
  const swal = useSwalWrapper();

  useEffect(() => {
    if (SelectedStoneDetail) {
      let tempCal = { pcs: 0, cts: 0, rap: 0, disc: 0, amt2: 0, amt: 0 };
      SelectedStoneDetail?.forEach((sdata) => {
        tempCal = {
          pcs: tempCal.pcs + 1,
          cts: tempCal.cts + (sdata.CARATS || sdata.FL_GROSS_WT),
          amt: Number(tempCal.amt) + Number(sdata.FL_AMT2),
        };
      });

      tempCal = {
        pcs: tempCal.pcs,
        amt: tempCal.amt?.toFixed(2),
        cts: tempCal.cts,
      };
      tempCal.pcs != 0 &&
        setStoneDataDetail({ ...tempCal, amt: Number(tempCal.amt) });
    }
  }, [SelectedStoneDetail, Data]);
  const handleSubmit = async (values, resetForm) => {
    // Handle form submission logic here
    if (values.term && values.FL_CURR_CODE && values.FL_CURR_CODE) {
      setButtonLoadng(true);
      await jwtAuthAxios
        .post("transation/jewel/polishOutward", {
          ...values,
          Party: userSelectedParty,
          transactionType: helperdata.PVID,
          StoneData: SelectedStoneDetail,
          isDetail: "Y",
          isMemo: "Y",
          trno: selectedMemoNo,
          memotrno: trid,
          memotrtype: type,
        })
        .then((res) => {
          swal.fire({
            icon: "success",
            text: res.data.message,
          });
          resetForm();
          callBack();
          handleClose();
        })
        .catch((e) => {
          swal.fire({
            icon: "error",
            text: "Internal server Error",
          });
        })
        .finally(() => {
          setButtonLoadng(false);
        });
    } else {
      swal.fire({
        icon: "error",
        text: "Please Fill Detail",
      });
    }
  };
  const jumboco = useJumboAuth();
  const [initialValues, setInitialValues] = useState({
    shippingNumber: "",
    term: "",
    shipBy: "",
    wat_per: helperdata?.TAX?.FL_TAX_PER,
    ShipingCharge: 0,
    CertCharge: 0,
    narration: "",
    OtherCharge: 0,
    is_p: false,
    Discount: 0,
    FL_CURR_CODE: "2",
    FL_CONV_RATE: CurrData.FL_CONV_RATE,
  });
  useEffect(() => {
    setInitialValues({
      ...initialValues,
      wat_per: helperdata?.TAX?.FL_TAX_PER,
    });
  }, [helperdata]);

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary,
  }));
  return (
    <Dialog open={open} sx={{ minWidth: "650px" }} onClose={handleClose}>
      <DialogTitle>Sold Shipping Information</DialogTitle>
      <DialogContent>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ values, resetForm, setFieldValue, errors, touched }) => (
            // <Form onSubmit={handleSubmit} >
            <>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <InputLabel>Select Bank</InputLabel>
                  <Field
                    size="small"
                    name="FL_BANK_CODE"
                    InputLabel="Select Bank"
                    as={Select}
                    fullWidth
                  >
                    <MenuItem value="">Select Select Bank</MenuItem>
                    {helperdata?.leadgerdetail?.map((item) => (
                      <MenuItem value={item.ACODE}>{item.ANAME}</MenuItem>
                    ))}
                  </Field>
                  {errors.FL_BANK_CODE && touched.FL_BANK_CODE && (
                    <div className="error">{errors.FL_BANK_CODE}</div>
                  )}
                </Grid>
                <Grid item lg={6}>
                  <Field
                    name="FL_CURR_CODE"
                    as={TextField}
                    style={{ margin: "5px 0" }}
                    InputProps={{ size: "small" }}
                    InputLabelProps={{ size: "small" }}
                    select
                    label="Currency Type"
                    fullWidth
                  >
                    {helperdata?.CURR?.map((option) => (
                      <MenuItem
                        key={option.FL_CURRENCY_ID}
                        onClick={(e) => {
                          setCurrencyName(option.FL_CURRENCY_NAME);
                        }}
                        fname={option.FL_CURRENCY_NAME}
                        value={option.FL_CURRENCY_ID}
                      >
                        {option.FL_CURRENCY_NAME}
                      </MenuItem>
                    ))}
                  </Field>
                </Grid>
                <Grid item lg={6}>
                  <Field
                    name="FL_CONV_RATE"
                    as={TextField}
                    style={{ margin: "5px 0" }}
                    InputProps={{ size: "small" }}
                    InputLabelProps={{ size: "small" }}
                    type="number"
                    label="Conv Rate"
                    fullWidth
                  />
                </Grid>
              </Grid>
              <Field
                name="term"
                as={TextField}
                InputProps={{ size: "small" }}
                InputLabelProps={{ size: "small" }}
                style={{ margin: "5px 0" }}
                select
                label="Payment Term"
                fullWidth
              >
                {helperdata?.TERM?.map((option) => (
                  <MenuItem
                    key={option.FL_TERM_CODE}
                    color="primary"
                    value={option.FL_TERM_CODE}
                  >
                    {option.FL_TERM_NAME}
                  </MenuItem>
                ))}
              </Field>
              <Field
                name="shipBy"
                as={TextField}
                style={{ margin: "5px 0" }}
                InputProps={{ size: "small" }}
                InputLabelProps={{ size: "small" }}
                select
                label="Ship By"
                fullWidth
              >
                {helperdata?.SHIPPEDBY?.map((option) => (
                  <MenuItem key={option.FL_PARA_VALUE} value={option.FL_GPID}>
                    {option.FL_PARA_VALUE}
                  </MenuItem>
                ))}
              </Field>
              <Grid container columnSpacing={2}>
                <Grid item lg={6}>
                  <Field
                    name="wat_per"
                    disabled={values.is_p == true}
                    as={TextField}
                    defaultValue={"0"}
                    type="number"
                    min={"0"}
                    style={{ margin: "5px 0" }}
                    InputProps={{ size: "small" }}
                    InputLabelProps={{ size: "small" }}
                    label="Vat Charge(%)"
                    fullWidth
                  />
                </Grid>
                <Grid item lg={6}>
                  <Field
                    name="ShipingCharge"
                    as={TextField}
                    type="number"
                    min={"0"}
                    defaultValue={"0"}
                    style={{ margin: "5px 0" }}
                    InputProps={{ size: "small" }}
                    InputLabelProps={{ size: "small" }}
                    label="Shiping Charge(AMT)"
                    fullWidth
                  />
                </Grid>
                <Grid item lg={6}>
                  <Field
                    name="CertCharge"
                    as={TextField}
                    type="number"
                    min={"0"}
                    defaultValue={"0"}
                    style={{ margin: "5px 0" }}
                    InputProps={{ size: "small" }}
                    InputLabelProps={{ size: "small" }}
                    label="Cert. Charge(AMT)"
                    fullWidth
                  />
                </Grid>
                <Grid item lg={6}>
                  <Field
                    name="OtherCharge"
                    as={TextField}
                    type="number"
                    min={"0"}
                    defaultValue={"0"}
                    style={{ margin: "5px 0" }}
                    InputProps={{ size: "small" }}
                    InputLabelProps={{ size: "small" }}
                    label="OtherCharge(AMT)"
                    fullWidth
                  />
                </Grid>
                <Grid item lg={6}>
                  <Field
                    name="Discount"
                    as={TextField}
                    type="number"
                    min={"0"}
                    defaultValue={"0"}
                    style={{ margin: "5px 0" }}
                    InputProps={{ size: "small" }}
                    InputLabelProps={{ size: "small" }}
                    label="Discount(-AMT)"
                    fullWidth
                  />
                </Grid>
                <Grid item lg={6}>
                  <Field
                    name="shippingNumber"
                    InputProps={{ size: "small" }}
                    InputLabelProps={{ size: "small" }}
                    as={TextField}
                    style={{ margin: "5px 0" }}
                    label="Shipping Number"
                    fullWidth
                  />
                </Grid>
              </Grid>
              <InputLabel>Naration</InputLabel>
              <Field
                size="small"
                component={TextareaAutosize}
                name="narration"
                label="Naration"
                minRows={3}
                onChange={(e) => setFieldValue("narration", e.target.value)}
                style={{ width: "100%" }}
                fullWidth
              />
              <Field
                name="is_p"
                render={({ field }) => (
                  <FormControlLabel
                    control={
                      <Checkbox
                        {...field}
                        onClick={() =>
                          !values.is_p
                            ? setFieldValue("wat_per", 0)
                            : setFieldValue(
                                "wat_per",
                                helperdata?.TAX?.FL_TAX_PER
                              )
                        }
                        style={{ margin: "5px 0" }}
                        size="small"
                        // Add any other Checkbox props here
                      />
                    }
                    label="IS P"
                    fullWidth
                  />
                )}
              />
              <Stack
                direction="row"
                divider={<Divider orientation="vertical" flexItem />}
                spacing={2}
                sx={{ mb: 1 }}
              >
                <Item>Pcs {stoneDataDetail?.pcs || 0}</Item>
                <Item>CTS {stoneDataDetail?.cts?.toFixed(2) || 0.0}</Item>
                <Item>vat% {values.wat_per || 0}</Item>
              </Stack>
              <Stack
                direction="row"
                divider={<Divider orientation="vertical" flexItem />}
                spacing={2}
                sx={{ mb: 1 }}
              >
                <Item>ShipingCharge ($AMT) = {values.ShipingCharge || 0}</Item>
                <Item>OtherCharge ($AMT) = {values.OtherCharge || 0}</Item>
                <Item>CertCharge ($AMT) = {values.CertCharge || 0}</Item>
                <Item>Disc($AMT) = (-{values.Discount || 0})</Item>
              </Stack>
              <Stack
                direction="row"
                divider={<Divider orientation="vertical" flexItem />}
                spacing={2}
                sx={{ mb: 1 }}
              >
                <Item>
                  Total Amt ($) =
                  {(
                    Number(
                      values.FL_CURR_CODE == 1
                        ? stoneDataDetail?.amt
                        : stoneDataDetail?.amt / jumboco?.curr?.Rate
                    ) +
                    ((stoneDataDetail?.amt || 0) * (values.wat_per || 0)) /
                      100 +
                    (values.CertCharge || 0) +
                    (values.OtherCharge || 0) +
                    (values.ShipingCharge || 0) -
                    (values.Discount || 0)
                  )?.toFixed(2)}
                </Item>
                <Item>
                  Total Amt ({CurrData?.CODE}) ={" "}
                  {(
                    Number(
                      values.FL_CURR_CODE == 2
                        ? stoneDataDetail?.amt
                        : stoneDataDetail?.amt * jumboco?.curr?.Rate
                    ) +
                    ((stoneDataDetail?.amt || 0) * (values.wat_per || 0)) /
                      100 +
                    (values.CertCharge || 0) +
                    (values.OtherCharge || 0) +
                    (values.ShipingCharge || 0) -
                    (values.Discount || 0) * values.FL_CONV_RATE
                  )?.toFixed(2)}
                </Item>
              </Stack>
              <LoadingButton
                loading={ButtonLoadng}
                variant="contained"
                color="primary"
                sx={{ display: "block", marginLeft: "auto", mt: 3 }}
                disabled={!values.FL_BANK_CODE}
                onClick={() => handleSubmit(values, resetForm)}
              >
                Sold
              </LoadingButton>
            </>
            // </Form>
          )}
        </Formik>
      </DialogContent>
    </Dialog>
  );
};
PartyTransactionDetail.Modulename = "OutwardDetail";
